import { BOOKING_STATUS } from '@/utils/config';

export const deepClone = (val) => {
	return JSON.parse(JSON.stringify(val));
};
/**
 * @param {function} fn
 * @param %{number} wait
 * @returns
 */
export const debounce = function (fn, wait) {
	let t;
	return function () {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, arguments), wait);
	};
};

export const throttle = function (fn, delay) {
	delay || (delay = 100);
	var throttle = false;
	return function () {
		if (throttle) {
			return;
		} // you no enter
		throttle = setTimeout(function () {
			// tail it - and do one last ajax request
			fn.apply(this, arguments);
			throttle = false;
		}, delay);
		fn.apply(this, arguments);
	};
};

/**
 * @param %{number} ms
 * @returns
 */
export const sleep = function (ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
};

/**
 * @param {*} obj
 * @returns boolean
 */
export const isEmptyArray = (arr) => {
	if (Array.isArray(arr)) {
		if (arr.length === 0) return true;
		else if (arr[0] === null || arr[0] === undefined) return true;
	}
	return false;
};

/**
 * @param {*} obj
 * @returns boolean
 */
export const isEmptyObject = (obj) => {
	return JSON.stringify(obj) === '{}';
};

export const isEmptyInObject = (obj) => {
	if (isEmptyObject(obj)) return true;
	for (const key in obj) {
		if (!obj[key]) return true;
		else if (isEmptyArray(obj[key])) {
			return true;
		}
	}
	return false;
};

export const resetErrorObj = (errorObj = {}) => {
	if (errorObj?.constructor !== Object) return {};

	for (let key in errorObj) {
		errorObj[key] = '';
	}

	return { ...errorObj };
};

export const isNumeric = (n) => {
	return !isNaN(parseFloat(n)) && !isNaN(n - 0);
};

/**
 * @param {*} input is File
 * @returns
 */
export const isFile = (input) => {
	if (input instanceof File) return true;
	else return false;
};
export const captchaEnabled = !!import.meta.env.VITE_RECAPTCHA_KEY;
/**
 * Parse an object into a flat key-value pair object.
 * @param {string} key - The key of the parse object.
 * @param {*} value - The object, array, or any value to parse.
 * @returns {Object} - The parsed data as a flat key-value pair object.
 */
export const parseForm = (key, value) => {
	const data = {};

	const handleObject = (prefix, obj) => {
		for (const prop in obj) {
			const currentKey = prefix ? `${prefix}[${prop}]` : prop;
			const currentValue = obj[prop];

			if (Array.isArray(currentValue)) {
				handleArray(currentKey, currentValue);
			} else if (isFile(currentValue)) {
				data[currentKey] = currentValue;
			} else if (typeof currentValue === 'object' && currentValue !== null) {
				handleObject(currentKey, currentValue);
			} else {
				if (currentValue !== null && currentValue !== undefined)
					data[currentKey] = currentValue;
			}
		}
	};

	const handleArray = (prefix, arr) => {
		arr.forEach((item, index) => {
			const currentKey = `${prefix}[${index}]`;

			if (Array.isArray(item)) {
				handleArray(currentKey, item);
			} else if (isFile(item)) {
				data[currentKey] = item;
			} else if (typeof item === 'object' && item !== null) {
				handleObject(currentKey, item);
			} else {
				if (item !== null && item !== undefined) data[currentKey] = item;
			}
		});
	};

	try {
		if (typeof value === 'object' && value !== null) {
			if (Array.isArray(value)) {
				handleArray(key, value);
			} else {
				handleObject(key, value);
			}
		} else {
			data[key] = value;
		}
	} catch (err) {
		console.error('An error occurred while parsing the form:', err);
	}

	return data;
};

export const formData = (data) => {
	const formData = new FormData();
	Object.keys(data).forEach((key) => {
		if (Array.isArray(data[key])) {
			if (data[key].length > 0) {
				data[key].forEach((value) => {
					formData.append(`${key}[]`, value.id || value);
				});
			} else {
				formData.append(key, []);
			}
		} else if (typeof data[key] === 'object' && data[key] !== null && data[key].id) {
			formData.append(key, data[key].id);
		} else {
			if (data[key] == null && data[key] == undefined) {
				formData.append(key, '');
			} else {
				formData.append(key, data[key]);
			}
		}
	});
	return formData;
};

/**
 * @param {*} obj
 * @returns string params
 */
export const serialize = function (obj) {
	if (!obj) return '';
	const str = [];
	for (const p in obj) {
		if (Array.isArray(obj[p])) {
			obj[p].forEach((e) => {
				//ex: [{from: 1},{to: 12}] -> urlParams=price[from]=1&price[to]=12
				if (typeof e === 'object') {
					// str.push(encodeURIComponent(p) + '['+d+']=' + encodeURIComponent(e))
					for (let key in e) {
						str.push(
							encodeURIComponent(p) + '[' + key + ']=' + encodeURIComponent(e[key])
						);
					}
				} else {
					str.push(encodeURIComponent(p) + '[]=' + encodeURIComponent(e));
				}
			});
		} else {
			str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
		}
	}
	return str.join('&');
};

/**
 *
 * @param {*} string
 * @returns word-word
 */
export const kebabCase = (string) =>
	string
		.replace(/([a-z])([A-Z])/g, '$1-$2') // Convert camelCase to kebab-case
		.replace(/[\s_]+/g, '-') // Replace spaces or underscores with hyphens
		.replace(/\//g, '-'); // Replace slashes with hyphens

/**
 * @param {array} xs
 * @param {function} f
 * @returns array
 */
export const groupBy = (x, f) => x.reduce((a, b) => ((a[f(b)] ||= []).push(b), a), {});

// DD-MM-YYYY
export const isDate = (date) => {
	return String(date).match(/^(0[1-9]|[12][0-9]|3[01])[- ](0[1-9]|1[012])[- ](19|20)\d\d$/);
};

/**
 * @param {*} val
 * return string currency
 */
export const formatCurrency = (val) => {
	return String(val || '').replace(/(\d)(?=(\d{3})+\b)/g, '$1.');
};

// Night-shift and public-holiday surcharges, mirroring App\Service\BookingPricingService (REQ-01).
const NIGHT_SHIFT_SURCHARGE_RATE = 0.1;
const HOLIDAY_SURCHARGE_MULTIPLIER = 1.5;
const NIGHT_SHIFT_START_HOUR = 22;
const NIGHT_SHIFT_END_HOUR = 6;
const HOLIDAY_DATES = [
	'2026-04-30',
	'2026-05-01',
	'2026-09-01',
	'2026-09-02',
	'2026-11-24',
	// Tết Nguyên Đán Đinh Mùi 2027
	'2027-02-06',
	'2027-02-07',
	'2027-02-08',
	'2027-02-09',
];

export const isNightShift = (date) => {
	if (!date) return false;
	const hour = new Date(date).getHours();
	return hour >= NIGHT_SHIFT_START_HOUR || hour < NIGHT_SHIFT_END_HOUR;
};

export const isHoliday = (date) => {
	if (!date) return false;
	const d = new Date(date);
	const isoDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
	return HOLIDAY_DATES.includes(isoDate);
};

export const applyBookingSurcharges = (basePrice, date) => {
	const holiday = isHoliday(date);
	const nightShift = isNightShift(date);
	const base = Number(basePrice) || 0;

	const afterHoliday = holiday ? base * HOLIDAY_SURCHARGE_MULTIPLIER : base;
	const finalPrice = nightShift ? afterHoliday * (1 + NIGHT_SHIFT_SURCHARGE_RATE) : afterHoliday;

	return {
		finalPrice: Math.round(finalPrice),
		holidayAmount: Math.round(afterHoliday - base),
		nightShiftAmount: Math.round(finalPrice - afterHoliday),
		isNightShift: nightShift,
		isHoliday: holiday,
	};
};

export const toStringUTF8 = (str) => {
	str = str.toLowerCase();
	str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
	str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
	str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
	str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
	str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
	str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
	str = str.replace(/đ/g, 'd');
	// Some system encode vietnamese combining accent as individual utf-8 characters
	str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // Huyền sắc hỏi ngã nặng
	str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // Â, Ê, Ă, Ơ, Ư
	return str;
};

export const mergeObjects = (...objs) => {
	return objs.reduce((prev, obj) => {
		Object.keys(obj).forEach((key) => {
			const pVal = prev[key];
			const oVal = obj[key];
			if (oVal === null || typeof oVal === 'undefined') return;
			if (Array.isArray(oVal) && !oVal.length) return;
			prev[key] =
				pVal && typeof pVal === 'object' && !Array.isArray(pVal)
					? mergeObjects(pVal, oVal)
					: oVal;
		});
		return prev;
	}, {});
};

/**
 *
 * @param {Object|String} error
 * @returns the error array
 */
export const getErrorArr = (error = {}) => {
	const tempObj = error?.data?.errors || { undefined: [error] };

	let errorArr = [];

	//prop is 1 array which contain 1 error message code
	for (let prop in tempObj) {
		errorArr.push(tempObj[prop][0]);
	}

	return errorArr;
};

export const mergeByKey = (target, source, prop) => {
	source.forEach((sourceElement) => {
		let targetElement = target.find((targetElement) => {
			return sourceElement[prop] == targetElement[prop];
		});
		targetElement ? Object.assign(targetElement, sourceElement) : target.push(sourceElement);
	});
	return target;
};

export const uniqueArrayByKey = (arr, key) => {
	const map = new Map();
	return arr.reduce((result, item) => {
		if (!map.has(item[key])) {
			map.set(item[key], true);
			result.push(item);
		}
		return result;
	}, []);
};

/**
 *
 * @param {*} number
 * @returns 1K , 10K , 100K, 1M ....
 */
export const abbreviateNumber = (number) => {
	if (number === 0) return '';
	const suffixes = ['', 'K', 'M', 'B'];
	const suffixNum = Math.floor(Math.log10(number) / 3);
	const shortNumber = parseFloat(
		(suffixNum != 0 ? number / Math.pow(1000, suffixNum) : number).toPrecision(2)
	);
	const suffix = suffixes[suffixNum];
	return `${shortNumber}${suffix}`;
};

export const isUrl = function (s) {
	var regexp =
		/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	return regexp.test(s);
};

export const imgExt = '.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp';
export const isImgName = (str) => {
	// Regular expression pattern to match common image file extensions
	const ext = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i;
	return ext.test(str);
};
export const isImgAndPdfName = (str) => {
	// Regular expression pattern to match common image file extensions
	const ext = /\.(jpg|jpeg|png|gif|bmp|svg|webp|pdf)$/i;
	return ext.test(str);
};

export const urltoFile = function (url, filename, mimeType) {
	return fetch(url)
		.then(function (res) {
			return res.arrayBuffer();
		})
		.then(function (buf) {
			return new File([buf], filename, { type: mimeType });
		});
};

export const toBase64 = (file) => {
	if (!file) return;

	const reader = new FileReader();

	return new Promise((resolve, reject) => {
		reader.onload = (fileEvent) => {
			resolve(fileEvent.target.result);
		}
		reader.onerror = () => {
			reject('oops, something went wrong with the file reader.');
		}
		reader.readAsDataURL(file);
	});
}

export const compressImage = async function (
	inputDataUri,
	quality = 80,
	outputFormat = 'image/jpeg'
) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = function () {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Set canvas dimensions to the same as the image
			canvas.width = img.width;
			canvas.height = img.height;

			// Draw image on canvas
			ctx.drawImage(img, 0, 0);

			// Compress and convert to data URI
			const compressedDataUri = canvas.toDataURL(outputFormat, quality/100);

			// Resolve the promise with the compressed data URI
			resolve(compressedDataUri);
		};
		img.onerror = function () {
			reject(new Error('Failed to load image'));
		};
		img.src = inputDataUri;
	});
};
// export const isImgAndPdfName = (str) => {
// 	// Regular expression pattern to match common image file extensions
// 	const ext = /\.(jpg|jpeg|png|gif|bmp|svg|webp|pdf)$/i;
// 	return ext.test(str);
// };

export const googleMapInit = (initMap = () => {}) => {
	if (window.google || window.google?.maps) initMap;
	const googleMapsScript = document.createElement('script');
	googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDreddPJLSQbrjQD9r4kTtmGlvdd0ZNsXA`;
	googleMapsScript.onload = initMap;
	document.head.appendChild(googleMapsScript);
};

// method address string get {lat, lng}
export const googleMapGeo = async (txt) => {
	if (!txt || !window.google || !window.google?.maps) return null;
	return new Promise((resolve, reject) => {
		const geocoder = new google.maps.Geocoder();
		geocoder.geocode({ address: txt }, function (results, status) {
			if (status === 'OK') {
				const location = results[0].geometry.location;
				const output = {
					lat: location.lat(),
					lng: location.lng(),
				};
				resolve(output);
			} else {
				reject(null);
			}
		});
	});
};

/**
 * @param {*} username
 * @param {*} passwordEncrypted
 * @returns
 */
export const generateJWT = (username, passwordEncrypted) => {
	var sha256 = function sha256(ascii) {
		function rightRotate(value, amount) {
			return (value >>> amount) | (value << (32 - amount));
		}

		var mathPow = Math.pow;
		var maxWord = mathPow(2, 32);
		var lengthProperty = 'length';
		var i, j; // Used as a counter across the whole file
		var result = '';

		var words = [];
		var asciiBitLength = ascii[lengthProperty] * 8;

		//* caching results is optional - remove/add slash from front of this line to toggle
		// Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
		// (we actually calculate the first 64, but extra values are just ignored)
		var hash = (sha256.h = sha256.h || []);
		// Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
		var k = (sha256.k = sha256.k || []);
		var primeCounter = k[lengthProperty];
		/*/
    var hash = [], k = [];
    var primeCounter = 0;
    //*/

		var isComposite = {};
		for (var candidate = 2; primeCounter < 64; candidate++) {
			if (!isComposite[candidate]) {
				for (i = 0; i < 313; i += candidate) {
					isComposite[i] = candidate;
				}
				hash[primeCounter] = (mathPow(candidate, 0.5) * maxWord) | 0;
				k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
			}
		}

		ascii += '\x80'; // Append Ƈ' bit (plus zero padding)
		while ((ascii[lengthProperty] % 64) - 56) ascii += '\x00'; // More zero padding
		for (i = 0; i < ascii[lengthProperty]; i++) {
			j = ascii.charCodeAt(i);
			if (j >> 8) return; // ASCII check: only accept characters in range 0-255
			words[i >> 2] |= j << (((3 - i) % 4) * 8);
		}
		words[words[lengthProperty]] = (asciiBitLength / maxWord) | 0;
		words[words[lengthProperty]] = asciiBitLength;

		// process each chunk
		for (j = 0; j < words[lengthProperty]; ) {
			var w = words.slice(j, (j += 16)); // The message is expanded into 64 words as part of the iteration
			var oldHash = hash;
			// This is now the undefinedworking hash", often labelled as variables a...g
			// (we have to truncate as well, otherwise extra entries at the end accumulate
			hash = hash.slice(0, 8);

			for (i = 0; i < 64; i++) {
				var i2 = i + j;
				// Expand the message into 64 words
				// Used below if
				var w15 = w[i - 15],
					w2 = w[i - 2];

				// Iterate
				var a = hash[0],
					e = hash[4];
				var temp1 =
					hash[7] +
					(rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) + // S1
					((e & hash[5]) ^ (~e & hash[6])) + // ch
					k[i] +
					// Expand the message schedule if needed
					(w[i] =
						i < 16
							? w[i]
							: (w[i - 16] +
									(rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) + // s0
									w[i - 7] +
									(rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10))) | // s1
							  0);
				// This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
				var temp2 =
					(rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) + // S0
					((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2])); // maj

				hash = [(temp1 + temp2) | 0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
				hash[4] = (hash[4] + temp1) | 0;
			}

			for (i = 0; i < 8; i++) {
				hash[i] = (hash[i] + oldHash[i]) | 0;
			}
		}

		for (i = 0; i < 8; i++) {
			for (j = 3; j + 1; j--) {
				var b = (hash[i] >> (j * 8)) & 255;
				result += (b < 16 ? 0 : '') + b.toString(16);
			}
		}
		return result;
	};
	let nonce = '';
	const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	for (let i = 0; i < 11; i++) {
		nonce += possible.charAt(Math.floor(Math.random() * possible.length));
	}
	const created = Math.floor(Date.now() / 1000);
	const passwordDigest = sha256(nonce + created + passwordEncrypted);
	return `/UsernameToken Username="${username}", PasswordDigest="${passwordDigest}", Nonce="${nonce}", Created="${created}"/`;
};

export const formatPhoneNumber = (phone) => {
	return phone.replaceAll(' ', '');
};

// Check if any errors are returned from server
export const hasResponseError = (res = null) => {
	return (
		res?.constructor !== Object ||
		res.data?.error ||
		res.status === 404 ||
		res.errors ||
		res.error ||
		res.status === 405
	);
};

export const getFullAddress = (item = {}) => {
	if (item?.constructor !== Object) return '';

	const wardFullName = item.ward?.fullName || item.addressWard?.fullName;
	const provinceFullName = item.province?.fullName || item.addressProvince?.fullName;

	const dataArr = [];
	if (item.address) {
		dataArr.push(item.address);
	}
	if (wardFullName) {
		dataArr.push(wardFullName);
	}
	if (provinceFullName) {
		dataArr.push(provinceFullName);
	}


	return dataArr.join(', ');
};

export const getNewAdressList = (list = []) => {
	if (!list?.length) return [];

	let newAddressList = [...list];
	newAddressList.sort((a, b) => !!b.isDefault - !!a.isDefault);

	newAddressList = newAddressList.map((item) => {
		item.fullAddress = `${item.address}, ${item.ward?.fullName}, ${item.province?.fullName}`;

		return item;
	});

	return [...newAddressList];
};

export const isBookingCompleted = (booking = {}) => {
	if (typeof booking !== 'object') return false;

	return (
		booking.status === BOOKING_STATUS.status_cancelled ||
		booking.status === BOOKING_STATUS.status_completed
	);
};

export const getTimeOfDate = (date = '') => {
  if (!date) return '';

  date = new Date(date);
  let hours = date.getHours();
  let minutes = date.getMinutes();

  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${hours}:${minutes}`;
};

export const b64ToBlob = (b64data = '') => {
	if (!b64data) return [];

	const byteCharacters = atob(b64data);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);

	return new Blob([byteArray]);
}

export const downloadFile = (blob, fileName) => {
	const link = document.createElement('a');

	// create a blobURI pointing to our Blob
	link.href = URL.createObjectURL(blob);
	link.download = fileName;

	// some browser needs the anchor to be in the doc
	document.body.append(link);

	link.click();
	link.remove();

	// in case the Blob uses a lot of memory
	setTimeout(() => URL.revokeObjectURL(link.href), 7000);
}

export const convertByteToMB = (bytes = 0, rounded = true) => {
	if (!bytes) return 0;

	const result = bytes/1024/1024;

	return !rounded ? result : Math.round(result);
}

export const setVisibleTab = (callback = () => {}) => {
	if (document.visibilityState === "visible") {
		// Reload data after the user
		// change tab in the browser
		callback();
	}
}

export const formatTime = (time = {}) => {
  if (time?.constructor !== Object) return '';

  const hours = time.hours < 9 ? `0${time.hours}` : time.hours;
  const minutes = time.minutes < 9 ? `0${time.minutes}` : time.minutes;

  return `${hours}:${minutes}`
};

export const getPhoneToView = (val = '') => {
	return String(val || '').replace(/(\d{3})(\d{3})(\d{4})/g, '$1 $2 $3');
}

export const isArrayValid = (val = []) => {
	if (!Array.isArray(val) || !val.length) return false;

	return true;
}

export const scrollToErrorEl = () => {
	const el = document.querySelector('.v-input__details > .v-messages');
	if (el) {
		window.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
	}
};

/**
 *
 * @param {*} res
 * @param {*} transFunc
 * @returns {string} error message
 * @Note
 * This function use the function [getFullAddress],
 * So you must have the function [getFullAddress]
 * in this file. Optimize later(^^)
 */
export const getRebookingError = (res = {}, transFunc = null) => {
	if(!res?.data?.errorMessage) return '';

	if (transFunc?.constructor !== Function) {
		transFunc = (text) => text;
	}

	const errorCodes = {
		productIsInactive: 'product_is_inactive',
		addressIsChanged: 'address_is_changed',
		nurseIsInactive: 'nurse_is_inactive',
		labIsInactive: 'lab_is_inactive'
	};
	let message = transFunc('error.requestFailed');
	switch (res.data.errorMessage.toLowerCase()) {
		case errorCodes.productIsInactive:
			message = transFunc('error.serviceIsInactive');
			break;
		case errorCodes.addressIsChanged:
			message = transFunc('error.addressIsChanged', {
				name: getFullAddress(res.data.data?.address)
			});
			break;
		case errorCodes.nurseIsInactive:
			message = transFunc('error.nurseIsInactive', {
				name: res.data.data?.nurse?.fullName
			});
			break;
		case errorCodes.labIsInactive:
			message = transFunc('error.labIsInactive');
			break;
		default: break;
	}

	return message;
};
